(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/bubble-win-message/assets/javascripts/components/description.js') >= 0) return;  svs.modules.push('/components/tur/bubble-win-message/assets/javascripts/components/description.js');
"use strict";


setGlobal('svs.tur.bubbleWinMessage.components.Description', _ref => {
  let {
    description
  } = _ref;
  return React.createElement("div", {
    className: "bubble-win-message-description"
  }, description);
});

 })(window);